const INITIAL_STATE = {
  data: {},
  errors: {},    
}
const lastThreePayment = (state = INITIAL_STATE, action) => {
  switch (action.type) {
  case 'GET_LAST_THREE_PAYMENTS_SUCCESSFULLY':
    return { ...INITIAL_STATE, data: action.data }
  case 'GET_LAST_THREE_PAYMENTS_Failed':
    return { ...INITIAL_STATE, errors: action.data }
  default:
    return { ...state }
  }
};
    
export default lastThreePayment;